export const localizedLink = locale => link => ({
  ...link,
  href:
    typeof link.href === 'string'
      ? link.href
      : link.href[locale] || link.href['en'],
});

export default { localizedLink };
